import { render, staticRenderFns } from "./edit-vendor-extra-modal.vue?vue&type=template&id=05140a8a"
import script from "./edit-vendor-extra-modal.vue?vue&type=script&lang=js"
export * from "./edit-vendor-extra-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports